import { defineComponent as l, inject as g, h as t } from "vue";
import { uploadInjectionKey as n } from "./ghl-ui.es1173.js";
import { throwError as p } from "./ghl-ui.es877.js";
const u = "__UPLOAD_DRAGGER__", c = l({
  name: "UploadDragger",
  [u]: !0,
  setup(i, {
    slots: a
  }) {
    const e = g(n, null);
    return e || p("upload-dragger", "`n-upload-dragger` must be placed inside `n-upload`."), () => {
      const {
        mergedClsPrefixRef: {
          value: r
        },
        mergedDisabledRef: {
          value: d
        },
        maxReachedRef: {
          value: o
        }
      } = e;
      return t("div", {
        class: [`${r}-upload-dragger`, (d || o) && `${r}-upload-dragger--disabled`]
      }, a);
    };
  }
});
export {
  c as default,
  u as uploadDraggerKey
};
